"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.costABQData = {
    "08242020": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("03/31/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 7069,
            fee1: 0,
            textbooks1: 273,
            supplies1: 121,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: "",
            tuition2: 7069,
            fee2: 0,
            textbooks2: 394,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: "",
            tuition3: 7069,
            fee3: 0,
            textbooks3: 0,
            supplies3: 493,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: "",
            tuition4: 7068,
            fee4: 0,
            textbooks4: 0,
            supplies4: 493,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: "",
            tuition5: 4524,
            fee5: 427,
            textbooks5: 0,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: "",
            tuition6: 4524,
            fee6: 426,
            textbooks6: 0,
            supplies6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("08/12/2021"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 7428,
            fee1: 0,
            textbooks1: 264,
            supplies1: 216,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: "",
            tuition2: 7428,
            fee2: 0,
            textbooks2: 264,
            supplies2: 216,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: "",
            tuition3: 4824,
            fee3: 755,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: "",
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("08/12/2021"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6803,
            fee1: 0,
            textbooks1: 388,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: "",
            tuition2: 6803,
            fee2: 0,
            textbooks2: 387,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: "",
            tuition3: 4659.5,
            fee3: 919.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: "",
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "10052020": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("05/12/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 7069,
            fee1: 0,
            textbooks1: 273,
            supplies1: 614,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/31/2021"),
            tuition2: 7069,
            fee2: 0,
            textbooks2: 394,
            supplies2: 493,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/16/2021"),
            tuition3: 7069,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/05/2021"),
            tuition4: 7068,
            fee4: 0,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("01/09/2022"),
            tuition5: 4524,
            fee5: 427,
            textbooks5: 0,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("03/13/2022"),
            tuition6: 4524,
            fee6: 426,
            textbooks6: 0,
            supplies6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("05/12/2022")
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("09/23/2021"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 7428,
            fee1: 0,
            textbooks1: 264,
            supplies1: 432,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/21/2021"),
            tuition2: 7428,
            fee2: 0,
            textbooks2: 264,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/14/2021"),
            tuition3: 4824,
            fee3: 755,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/23/2021"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("09/24/2021"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6803,
            fee1: 0,
            textbooks1: 388,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/21/2021"),
            tuition2: 6803,
            fee2: 0,
            textbooks2: 387,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/04/2021"),
            tuition3: 4659.5,
            fee3: 919.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/24/2021"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "11162020": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("02/18/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 7225,
            fee1: 0,
            textbooks1: 89,
            supplies1: 650,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/04/2021"),
            tuition2: 7225,
            fee2: 0,
            textbooks2: 210,
            supplies2: 457,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/15/2021"),
            tuition3: 5483,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/07/2021"),
            tuition4: 5483,
            fee4: 73,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("02/18/2022"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("11/04/2021"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 7428,
            fee1: 0,
            textbooks1: 264,
            supplies1: 432,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/04/2021"),
            tuition2: 7428,
            fee2: 0,
            textbooks2: 264,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/15/2021"),
            tuition3: 4824,
            fee3: 755,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/04/2021"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("11/05/2021"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6803,
            fee1: 0,
            textbooks1: 388,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/04/2021"),
            tuition2: 6803,
            fee2: 0,
            textbooks2: 387,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/15/2021"),
            tuition3: 4659.5,
            fee3: 919.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/05/2021"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("05/12/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6000,
            fee1: 392,
            textbooks1: 431,
            supplies1: 432,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("03/14/2021"),
            tuition2: 6000,
            fee2: 393,
            textbooks2: 430,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/04/2021"),
            tuition3: 6000,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("10/17/2021"),
            tuition4: 6000,
            fee4: 0,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("02/20/2022"),
            tuition5: 4800,
            fee5: 117,
            textbooks5: 0,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("05/12/2022"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("08/12/2021"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 5952,
            fee1: 116,
            textbooks1: 181,
            supplies1: 415,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/04/2021"),
            tuition2: 5951,
            fee2: 116,
            textbooks2: 596,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/15/2021"),
            tuition3: 3968,
            fee3: 700,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/05/2021"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "01112021": {
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("12/16/2021"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2021",
            tuition1: 7428,
            fee1: 0,
            textbooks1: 264,
            supplies1: 432,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("05/16/2021"),
            tuition2: 7428,
            fee2: 0,
            textbooks2: 264,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/26/2021"),
            tuition3: 4824,
            fee3: 755,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("12/16/2021"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("12/17/2021"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2021",
            tuition1: 6803,
            fee1: 0,
            textbooks1: 388,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("05/16/2021"),
            tuition2: 6803,
            fee2: 0,
            textbooks2: 387,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/26/2021"),
            tuition3: 4659.5,
            fee3: 919.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("12/17/2021"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("03/31/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2021",
            tuition1: 7225,
            fee1: 0,
            textbooks1: 89,
            supplies1: 650,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("05/16/2021"),
            tuition2: 7225,
            fee2: 0,
            textbooks2: 210,
            supplies2: 457,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/26/2021"),
            tuition3: 5483,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("01/09/2022"),
            tuition4: 5483,
            fee4: 73,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("03/31/2022"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 91.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("06/23/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6000,
            fee1: 392,
            textbooks1: 431,
            supplies1: 432,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/25/2021"),
            tuition2: 6000,
            fee2: 393,
            textbooks2: 430,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/15/2021"),
            tuition3: 6000,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/28/2021"),
            tuition4: 6000,
            fee4: 0,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("04/03/2022"),
            tuition5: 4800,
            fee5: 117,
            textbooks5: 0,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("06/23/2022"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("12/17/2021"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 5952,
            fee1: 116,
            textbooks1: 181,
            supplies1: 415,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("05/16/2021"),
            tuition2: 5951,
            fee2: 116,
            textbooks2: 596,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/26/2021"),
            tuition3: 3968,
            fee3: 700,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("12/17/2021"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MT: {
            programType: "Contact_Clock",
            programHour: 750,
            programLength: 9,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("09/24/2021"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2021",
            tuition1: 5625,
            fee1: 199,
            textbooks1: 508,
            supplies1: 316,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("05/16/2021"),
            tuition2: 5625,
            fee2: 1022,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/24/2021"),
            tuition3: "",
            fee3: "",
            textbooks3: "",
            supplies3: "",
            other3: "",
            paymentReceive3: "",
            cancellationFee3: "",
            endDate3: "",
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "02222021": {
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("02/17/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2021",
            tuition1: 7428,
            fee1: 0,
            textbooks1: 264,
            supplies1: 432,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/04/2021"),
            tuition2: 7428,
            fee2: 0,
            textbooks2: 264,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/07/2021"),
            tuition3: 4824,
            fee3: 755,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("02/17/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("02/18/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2021",
            tuition1: 6803,
            fee1: 0,
            textbooks1: 388,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/04/21"),
            tuition2: 6803,
            fee2: 0,
            textbooks2: 387,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/07/2021"),
            tuition3: 4659.5,
            fee3: 919.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("02/18/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("05/13/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2021",
            tuition1: 7225,
            fee1: 0,
            textbooks1: 89,
            supplies1: 650,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/04/2021"),
            tuition2: 7225,
            fee2: 0,
            textbooks2: 210,
            supplies2: 457,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/07/2021"),
            tuition3: 5483,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("02/20/2022"),
            tuition4: 5483,
            fee4: 73,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("05/13/2022"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 91.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("08/11/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6000,
            fee1: 392,
            textbooks1: 431,
            supplies1: 432,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("06/06/2021"),
            tuition2: 6000,
            fee2: 393,
            textbooks2: 430,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/26/2021"),
            tuition3: 6000,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("01/30/2022"),
            tuition4: 6000,
            fee4: 0,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("05/15/2022"),
            tuition5: 4800,
            fee5: 117,
            textbooks5: 0,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("08/11/2022"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("02/18/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 5952,
            fee1: 116,
            textbooks1: 181,
            supplies1: 415,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/04/2021"),
            tuition2: 5951,
            fee2: 116,
            textbooks2: 596,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/07/2021"),
            tuition3: 3968,
            fee3: 700,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("02/18/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MT: {
            programType: "Contact_Clock",
            programHour: 750,
            programLength: 9,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("11/05/2021"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2021",
            tuition1: 5625,
            fee1: 199,
            textbooks1: 508,
            supplies1: 316,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/04/2021"),
            tuition2: 5625,
            fee2: 1022,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/05/2021"),
            tuition3: "",
            fee3: "",
            textbooks3: "",
            supplies3: "",
            other3: "",
            paymentReceive3: "",
            cancellationFee3: "",
            endDate3: "",
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "04052021": {
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("04/01/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2021",
            tuition1: 7380,
            fee1: 0,
            textbooks1: 264,
            supplies1: 566,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("08/15/2021"),
            tuition2: 7380,
            fee2: 0,
            textbooks2: 264,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/09/2022"),
            tuition3: 4920,
            fee3: 621,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("04/01/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("04/01/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2021",
            tuition1: 6804,
            fee1: 0,
            textbooks1: 609,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("08/15/2021"),
            tuition2: 6804,
            fee2: 0,
            textbooks2: 609,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/09/2022"),
            tuition3: 4534.5,
            fee3: 599.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("04/01/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("06/24/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2021",
            tuition1: 7095,
            fee1: 0,
            textbooks1: 299,
            supplies1: 1491,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("08/15/2021"),
            tuition2: 7095,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/09/2022"),
            tuition3: 5397,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("04/03/2022"),
            tuition4: 5397,
            fee4: 121,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("06/24/2022"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 91.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("09/23/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6080,
            fee1: 0,
            textbooks1: 431,
            supplies1: 283,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/25/2021"),
            tuition2: 6080,
            fee2: 0,
            textbooks2: 430,
            supplies2: 283,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/07/2021"),
            tuition3: 5920,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("03/13/2022"),
            tuition4: 5920,
            fee4: 0,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("07/03/2022"),
            tuition5: 4800,
            fee5: 768,
            textbooks5: 0,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("09/23/2022"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("04/01/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 5714,
            fee1: 0,
            textbooks1: 777,
            supplies1: 591,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("08/15/2021"),
            tuition2: 5714,
            fee2: 180,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/09/2022"),
            tuition3: 4443,
            fee3: 576,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("04/01/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MT: {
            programType: "Contact_Clock",
            programHour: 750,
            programLength: 9,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("12/17/2021"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2021",
            tuition1: 5625,
            fee1: 441,
            textbooks1: 508,
            supplies1: 384,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("08/15/2021"),
            tuition2: 5625,
            fee2: 712,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("12/17/2021"),
            tuition3: "",
            fee3: "",
            textbooks3: "",
            supplies3: "",
            other3: "",
            paymentReceive3: "",
            cancellationFee3: "",
            endDate3: "",
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "05172021": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("08/12/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 7095,
            fee1: 0,
            textbooks1: 299,
            supplies1: 1491,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/26/2021"),
            tuition2: 7095,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/20/2022"),
            tuition3: 5397,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("05/15/2022"),
            tuition4: 5397,
            fee4: 121,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("08/12/2022"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("05/13/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 5714,
            fee1: 0,
            textbooks1: 777,
            supplies1: 591,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/26/2021"),
            tuition2: 5714,
            fee2: 180,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/20/2022"),
            tuition3: 4443,
            fee3: 576,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("05/13/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("05/13/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 6804,
            fee1: 0,
            textbooks1: 609,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/26/2021"),
            tuition2: 6804,
            fee2: 0,
            textbooks2: 609,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/20/2022"),
            tuition3: 4534.5,
            fee3: 599.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("05/13/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("05/13/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 7380,
            fee1: 0,
            textbooks1: 264,
            supplies1: 566,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/26/2021"),
            tuition2: 7380,
            fee2: 0,
            textbooks2: 264,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/20/2022"),
            tuition3: 4920,
            fee3: 621,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("05/13/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MT: {
            programType: "Contact_Clock",
            programHour: 750,
            programLength: 9,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("02/18/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 5625,
            fee1: 441,
            textbooks1: 508,
            supplies1: 384,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/28/2021"),
            tuition2: 5625,
            fee2: 712,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/18/2022"),
            tuition3: "",
            fee3: "",
            textbooks3: "",
            supplies3: "",
            other3: "",
            paymentReceive3: "",
            cancellationFee3: "",
            endDate3: "",
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 91.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("11/04/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6080,
            fee1: 0,
            textbooks1: 431,
            supplies1: 283,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/05/2021"),
            tuition2: 6080,
            fee2: 0,
            textbooks2: 430,
            supplies2: 283,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/09/2022"),
            tuition3: 5920,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("04/24/2022"),
            tuition4: 5920,
            fee4: 0,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("08/14/2022"),
            tuition5: 4800,
            fee5: 768,
            textbooks5: 0,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("11/04/2022"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "07062021": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("09/23/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 7095,
            fee1: 0,
            textbooks1: 299,
            supplies1: 1491,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/07/2021"),
            tuition2: 7095,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/03/2022"),
            tuition3: 5397,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("07/03/2022"),
            tuition4: 5397,
            fee4: 121,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("09/23/2022"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("06/24/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 5714,
            fee1: 0,
            textbooks1: 777,
            supplies1: 591,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/07/2021"),
            tuition2: 5714,
            fee2: 180,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/03/2022"),
            tuition3: 4443,
            fee3: 576,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("06/24/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("06/24/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 6804,
            fee1: 0,
            textbooks1: 609,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/07/2021"),
            tuition2: 6804,
            fee2: 0,
            textbooks2: 609,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/03/2022"),
            tuition3: 4534.5,
            fee3: 599.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("06/24/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("06/24/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 7380,
            fee1: 0,
            textbooks1: 264,
            supplies1: 566,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/07/2021"),
            tuition2: 7380,
            fee2: 0,
            textbooks2: 264,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/03/2022"),
            tuition3: 4920,
            fee3: 621,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("06/24/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MT: {
            programType: "Contact_Clock",
            programHour: 750,
            programLength: 9,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("04/02/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 5625,
            fee1: 441,
            textbooks1: 508,
            supplies1: 384,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/09/2021"),
            tuition2: 5625,
            fee2: 712,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/02/2022"),
            tuition3: "",
            fee3: "",
            textbooks3: "",
            supplies3: "",
            other3: "",
            paymentReceive3: "",
            cancellationFee3: "",
            endDate3: "",
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 91.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("12/16/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6080,
            fee1: 0,
            textbooks1: 431,
            supplies1: 283,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("10/17/2021"),
            tuition2: 6080,
            fee2: 0,
            textbooks2: 430,
            supplies2: 283,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/20/2022"),
            tuition3: 5920,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("06/05/2022"),
            tuition4: 5920,
            fee4: 0,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("09/25/2022"),
            tuition5: 4800,
            fee5: 768,
            textbooks5: 0,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("12/16/2022"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "08162021": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("11/04/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 7095,
            fee1: 0,
            textbooks1: 299,
            supplies1: 1491,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/09/2022"),
            tuition2: 7095,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/15/2022"),
            tuition3: 5397,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("08/14/2022"),
            tuition4: 5397,
            fee4: 121,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("11/04/2022"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("08/12/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 5714,
            fee1: 0,
            textbooks1: 777,
            supplies1: 591,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/09/2022"),
            tuition2: 5714,
            fee2: 180,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/15/2022"),
            tuition3: 4443,
            fee3: 576,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("08/12/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("08/12/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 6804,
            fee1: 0,
            textbooks1: 609,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/09/2022"),
            tuition2: 6804,
            fee2: 0,
            textbooks2: 609,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/15/2022"),
            tuition3: 4534.5,
            fee3: 599.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("08/12/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("08/12/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 7380,
            fee1: 0,
            textbooks1: 264,
            supplies1: 566,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/09/2022"),
            tuition2: 7380,
            fee2: 0,
            textbooks2: 264,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/15/2022"),
            tuition3: 4920,
            fee3: 621,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("08/12/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MT: {
            programType: "Contact_Clock",
            programHour: 750,
            programLength: 9,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("05/13/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 5625,
            fee1: 441,
            textbooks1: 508,
            supplies1: 384,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/11/2022"),
            tuition2: 5625,
            fee2: 712,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/13/2022"),
            tuition3: "",
            fee3: "",
            textbooks3: "",
            supplies3: "",
            other3: "",
            paymentReceive3: "",
            cancellationFee3: "",
            endDate3: "",
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 91.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("02/17/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6080,
            fee1: 0,
            textbooks1: 431,
            supplies1: 283,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/28/2021"),
            tuition2: 6080,
            fee2: 0,
            textbooks2: 430,
            supplies2: 283,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/03/2022"),
            tuition3: 5920,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("07/24/2022"),
            tuition4: 5920,
            fee4: 0,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("11/06/2022"),
            tuition5: 4800,
            fee5: 768,
            textbooks5: 0,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("02/17/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "09272021": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("12/16/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "September 2021",
            tuition1: 7095,
            fee1: 0,
            textbooks1: 299,
            supplies1: 1491,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/20/2022"),
            tuition2: 7095,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/03/2022"),
            tuition3: 5397,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/25/2022"),
            tuition4: 5397,
            fee4: 121,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("12/16/2022"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("09/23/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "September 2021",
            tuition1: 5714,
            fee1: 0,
            textbooks1: 777,
            supplies1: 591,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/20/2022"),
            tuition2: 5714,
            fee2: 180,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/03/2022"),
            tuition3: 4443,
            fee3: 576,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/23/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("09/23/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "September 2021",
            tuition1: 6804,
            fee1: 0,
            textbooks1: 609,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/20/2022"),
            tuition2: 6804,
            fee2: 0,
            textbooks2: 609,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/03/2022"),
            tuition3: 4534.5,
            fee3: 599.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/23/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("09/23/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "September 2021",
            tuition1: 7380,
            fee1: 0,
            textbooks1: 264,
            supplies1: 566,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/20/2022"),
            tuition2: 7380,
            fee2: 0,
            textbooks2: 264,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/03/2022"),
            tuition3: 4920,
            fee3: 621,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/23/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MT: {
            programType: "Contact_Clock",
            programHour: 750,
            programLength: 9,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("06/24/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "September 2021",
            tuition1: 5625,
            fee1: 441,
            textbooks1: 508,
            supplies1: 384,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/27/2022"),
            tuition2: 5625,
            fee2: 712,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("06/24/2022"),
            tuition3: "",
            fee3: "",
            textbooks3: "",
            supplies3: "",
            other3: "",
            paymentReceive3: "",
            cancellationFee3: "",
            endDate3: "",
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 91.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("03/30/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "September 2021",
            tuition1: 6080,
            fee1: 0,
            textbooks1: 431,
            supplies1: 283,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/30/2022"),
            tuition2: 6080,
            fee2: 0,
            textbooks2: 430,
            supplies2: 283,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/15/2022"),
            tuition3: 5920,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/05/2022"),
            tuition4: 5920,
            fee4: 0,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("01/08/2023"),
            tuition5: 4800,
            fee5: 768,
            textbooks5: 0,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("03/30/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 90.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("03/30/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "September 2021",
            tuition1: 5145,
            fee1: 0,
            textbooks1: 297,
            supplies1: 591,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/30/2022"),
            tuition2: 5144,
            fee2: 0,
            textbooks2: 296,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/15/2022"),
            tuition3: 5145,
            fee3: 0,
            textbooks3: 195,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/05/2022"),
            tuition4: 5144,
            fee4: 180,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("01/08/2023"),
            tuition5: 3766.5,
            fee5: 576,
            textbooks5: 259,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("03/30/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "11082021": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("02/17/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "November 2021",
            tuition1: 7095,
            fee1: 0,
            textbooks1: 299,
            supplies1: 1491,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/03/2022"),
            tuition2: 7095,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/14/2022"),
            tuition3: 5397,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/06/2022"),
            tuition4: 5397,
            fee4: 121,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("02/17/2023"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("11/04/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "November 2021",
            tuition1: 5714,
            fee1: 0,
            textbooks1: 777,
            supplies1: 591,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/03/2022"),
            tuition2: 5714,
            fee2: 180,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/14/2022"),
            tuition3: 4443,
            fee3: 576,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/04/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("11/04/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "November 2021",
            tuition1: 6804,
            fee1: 0,
            textbooks1: 609,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/03/2022"),
            tuition2: 6804,
            fee2: 0,
            textbooks2: 609,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/14/2022"),
            tuition3: 4534.5,
            fee3: 599.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/04/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("11/04/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "November 2021",
            tuition1: 7380,
            fee1: 0,
            textbooks1: 264,
            supplies1: 566,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/03/2022"),
            tuition2: 7380,
            fee2: 0,
            textbooks2: 264,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/14/2022"),
            tuition3: 4920,
            fee3: 621,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/04/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MT: {
            programType: "Contact_Clock",
            programHour: 750,
            programLength: 9,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("08/12/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "November 2021",
            tuition1: 5625,
            fee1: 441,
            textbooks1: 508,
            supplies1: 384,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/10/2022"),
            tuition2: 5625,
            fee2: 712,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/12/2022"),
            tuition3: "",
            fee3: "",
            textbooks3: "",
            supplies3: "",
            other3: "",
            paymentReceive3: "",
            cancellationFee3: "",
            endDate3: "",
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 91.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("05/11/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "November 2021",
            tuition1: 6080,
            fee1: 0,
            textbooks1: 431,
            supplies1: 283,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("03/13/2022"),
            tuition2: 6080,
            fee2: 0,
            textbooks2: 430,
            supplies2: 283,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/03/2022"),
            tuition3: 5920,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("10/16/2022"),
            tuition4: 5920,
            fee4: 0,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("02/19/2023"),
            tuition5: 4800,
            fee5: 768,
            textbooks5: 0,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("05/11/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 90.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("05/11/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "November 2021",
            tuition1: 5145,
            fee1: 0,
            textbooks1: 297,
            supplies1: 591,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("03/13/2022"),
            tuition2: 5144,
            fee2: 0,
            textbooks2: 296,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/03/2022"),
            tuition3: 5145,
            fee3: 0,
            textbooks3: 195,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("10/16/2022"),
            tuition4: 5144,
            fee4: 180,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("02/19/2023"),
            tuition5: 3766.5,
            fee5: 576,
            textbooks5: 259,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("05/11/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "01102022": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("03/31/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2022",
            tuition1: 7055,
            fee1: 0,
            textbooks1: 245,
            supplies1: 1375,
            uniform1: 116,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("05/15/2022"),
            tuition2: 7055,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/25/2022"),
            tuition3: 5497.84,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("01/08/2023"),
            tuition4: 5497.84,
            fee4: 0,
            textbooks4: 54,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("03/31/2023"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: 0,
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("12/16/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2022",
            tuition1: 6330,
            fee1: 0,
            textbooks1: 626,
            supplies1: 559,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("05/15/2022"),
            tuition2: 6330,
            fee2: 0,
            textbooks2: 97,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/25/2022"),
            tuition3: 4922,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("12/16/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: 0,
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: 0,
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC_DISABLED: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("12/16/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2022",
            tuition1: 6804,
            fee1: 0,
            textbooks1: 609,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("05/15/2022"),
            tuition2: 6804,
            fee2: 0,
            textbooks2: 609,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/25/2022"),
            tuition3: 4534.5,
            fee3: 599.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("12/16/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("12/16/2022"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2022",
            tuition1: 7451,
            fee1: 0,
            textbooks1: 279,
            supplies1: 532,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("05/15/2022"),
            tuition2: 7451,
            fee2: 0,
            textbooks2: 139,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/25/2022"),
            tuition3: 5499.4,
            fee3: 0,
            textbooks3: 110,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("12/16/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: 0,
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: 0,
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MT: {
            programType: "Contact_Clock",
            programHour: 750,
            programLength: 9,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("09/23/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2022",
            tuition1: 6203,
            fee1: 0,
            textbooks1: 454,
            supplies1: 315,
            uniform1: 68,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("05/15/2022"),
            tuition2: 6202,
            fee2: 54,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/23/2022"),
            tuition3: "",
            fee3: "",
            textbooks3: "",
            supplies3: "",
            other3: "",
            paymentReceive3: "",
            cancellationFee3: "",
            endDate3: "",
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 90,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("06/23/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2022",
            tuition1: 6746,
            fee1: 0,
            textbooks1: 225,
            supplies1: 532,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/24/2022"),
            tuition2: 6746,
            fee2: 0,
            textbooks2: 139,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/14/2022"),
            tuition3: 6746,
            fee3: 0,
            textbooks3: 109,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/27/2022"),
            tuition4: 6746,
            fee4: 0,
            textbooks4: 280,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("04/02/2023"),
            tuition5: 6584.1,
            fee5: 108,
            textbooks5: 0,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("06/23/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 90.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("06/23/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2022",
            tuition1: 5700,
            fee1: 0,
            textbooks1: 605,
            supplies1: 559,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/24/2022"),
            tuition2: 5700,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/14/2022"),
            tuition3: 5699,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/27/2022"),
            tuition4: 5699,
            fee4: 0,
            textbooks4: 194,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("04/02/2023"),
            tuition5: 4171,
            fee5: 0,
            textbooks5: 194,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("06/23/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ATM_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 94.5,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("08/11/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2022",
            tuition1: 6190,
            fee1: 0,
            textbooks1: 244,
            supplies1: 1375,
            uniform1: 116,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/24/2022"),
            tuition2: 6189,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/14/2022"),
            tuition3: 6189,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/27/2022"),
            tuition4: 6189,
            fee4: 0,
            textbooks4: 54,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("04/02/2023"),
            tuition5: 4097.11,
            fee5: 0,
            textbooks5: 162,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("06/04/2023"),
            tuition6: 4097.10,
            fee6: 0,
            textbooks6: 161,
            supplies6: 0,
            uniform6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("08/11/2023")
        }
    },
    "02212022": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("05/12/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "February 2022",
            tuition1: 7055,
            fee1: 0,
            textbooks1: 245,
            supplies1: 1375,
            uniform1: 116,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/04/2022"),
            tuition2: 7055,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/06/2022"),
            tuition3: 5497.84,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("02/05/2023"),
            tuition4: 5497.84,
            fee4: 0,
            textbooks4: 54,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("05/12/2023"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: 0,
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("02/17/2023"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "February 2022",
            tuition1: 6330,
            fee1: 0,
            textbooks1: 626,
            supplies1: 559,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/04/2022"),
            tuition2: 6330,
            fee2: 0,
            textbooks2: 97,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/06/2022"),
            tuition3: 4922,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("02/17/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: 0,
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: 0,
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC_DISABLED: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("02/17/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "February 2022",
            tuition1: 6804,
            fee1: 0,
            textbooks1: 609,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/04/2022"),
            tuition2: 6804,
            fee2: 0,
            textbooks2: 609,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/06/2022"),
            tuition3: 4534.5,
            fee3: 599.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("02/17/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("02/17/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "February 2022",
            tuition1: 7451,
            fee1: 0,
            textbooks1: 279,
            supplies1: 532,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/04/2022"),
            tuition2: 7451,
            fee2: 0,
            textbooks2: 139,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/06/2022"),
            tuition3: 5499.4,
            fee3: 0,
            textbooks3: 110,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("02/17/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: 0,
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: 0,
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MT: {
            programType: "Contact_Clock",
            programHour: 750,
            programLength: 9,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("11/04/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "February 2022",
            tuition1: 6203,
            fee1: 0,
            textbooks1: 454,
            supplies1: 315,
            uniform1: 68,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/11/2022"),
            tuition2: 6202,
            fee2: 54,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/04/2022"),
            tuition3: "",
            fee3: "",
            textbooks3: "",
            supplies3: "",
            other3: "",
            paymentReceive3: "",
            cancellationFee3: "",
            endDate3: "",
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 90,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("08/11/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "February 2022",
            tuition1: 6746,
            fee1: 0,
            textbooks1: 225,
            supplies1: 532,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("06/05/2022"),
            tuition2: 6746,
            fee2: 0,
            textbooks2: 139,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/25/2022"),
            tuition3: 6746,
            fee3: 0,
            textbooks3: 109,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("01/29/2023"),
            tuition4: 6746,
            fee4: 0,
            textbooks4: 280,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("05/14/2023"),
            tuition5: 6584.1,
            fee5: 108,
            textbooks5: 0,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("08/11/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 90.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("08/11/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "February 2022",
            tuition1: 6728,
            fee1: 0,
            textbooks1: 605,
            supplies1: 559,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("06/05/2022"),
            tuition2: 6728,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/25/2022"),
            tuition3: 6728,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("01/29/2023"),
            tuition4: 6728,
            fee4: 0,
            textbooks4: 194,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("05/14/2023"),
            tuition5: 6445.2,
            fee5: 0,
            textbooks5: 194,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("08/11/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ATM_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 94.5,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("09/22/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "February 2022",
            tuition1: 6190,
            fee1: 0,
            textbooks1: 244,
            supplies1: 1375,
            uniform1: 116,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("06/05/2022"),
            tuition2: 6189,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/25/2022"),
            tuition3: 6189,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("01/29/2023"),
            tuition4: 6189,
            fee4: 0,
            textbooks4: 54,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("05/14/2023"),
            tuition5: 4097.11,
            fee5: 0,
            textbooks5: 162,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("07/23/2023"),
            tuition6: 4097.10,
            fee6: 0,
            textbooks6: 161,
            supplies6: 0,
            uniform6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("09/22/2023")
        }
    },
    "04042022": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("06/23/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "April 2022",
            tuition1: 7055,
            fee1: 0,
            textbooks1: 245,
            supplies1: 1375,
            uniform1: 116,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("08/14/2022"),
            tuition2: 7055,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/08/2023"),
            tuition3: 5497.84,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("04/02/2023"),
            tuition4: 5497.84,
            fee4: 0,
            textbooks4: 54,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("06/23/2023"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: 0,
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("03/31/2023"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "April 2022",
            tuition1: 6330,
            fee1: 0,
            textbooks1: 626,
            supplies1: 559,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("08/14/2022"),
            tuition2: 6330,
            fee2: 0,
            textbooks2: 97,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/08/2023"),
            tuition3: 4922,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("03/31/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: 0,
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: 0,
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC_DISABLED: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("03/31/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "April 2022",
            tuition1: 6804,
            fee1: 0,
            textbooks1: 609,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("08/14/2022"),
            tuition2: 6804,
            fee2: 0,
            textbooks2: 609,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/08/2023"),
            tuition3: 4534.5,
            fee3: 599.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("03/31/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("03/31/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "April 2022",
            tuition1: 7451,
            fee1: 0,
            textbooks1: 279,
            supplies1: 532,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("08/14/2022"),
            tuition2: 7451,
            fee2: 0,
            textbooks2: 139,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/08/2023"),
            tuition3: 5499.4,
            fee3: 0,
            textbooks3: 110,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("03/31/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: 0,
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: 0,
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MT: {
            programType: "Contact_Clock",
            programHour: 750,
            programLength: 9,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("12/16/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "April 2022",
            tuition1: 6203,
            fee1: 0,
            textbooks1: 454,
            supplies1: 315,
            uniform1: 68,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("08/21/2022"),
            tuition2: 6202,
            fee2: 0,
            textbooks2: 54,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("12/16/2022"),
            tuition3: "",
            fee3: "",
            textbooks3: "",
            supplies3: "",
            other3: "",
            paymentReceive3: "",
            cancellationFee3: "",
            endDate3: "",
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 90,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("09/22/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "April 2022",
            tuition1: 6746,
            fee1: 0,
            textbooks1: 225,
            supplies1: 532,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/24/2022"),
            tuition2: 6746,
            fee2: 0,
            textbooks2: 139,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/06/2022"),
            tuition3: 6746,
            fee3: 0,
            textbooks3: 109,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("03/12/2023"),
            tuition4: 6746,
            fee4: 0,
            textbooks4: 280,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("07/02/2023"),
            tuition5: 6584.1,
            fee5: 0,
            textbooks5: 108,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("09/22/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 90.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("09/22/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "April 2022",
            tuition1: 5700,
            fee1: 0,
            textbooks1: 605,
            supplies1: 559,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/24/2022"),
            tuition2: 5700,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/06/2022"),
            tuition3: 5699,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("03/12/2023"),
            tuition4: 5699,
            fee4: 0,
            textbooks4: 194,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("07/03/2023"),
            tuition5: 4171,
            fee5: 0,
            textbooks5: 194,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("09/22/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ATM_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 94.5,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("11/03/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "April 2022",
            tuition1: 6190,
            fee1: 0,
            textbooks1: 244,
            supplies1: 1375,
            uniform1: 116,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/24/2022"),
            tuition2: 6189,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/06/2022"),
            tuition3: 6189,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("03/12/2023"),
            tuition4: 6189,
            fee4: 0,
            textbooks4: 54,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("07/02/2023"),
            tuition5: 4097.11,
            fee5: 0,
            textbooks5: 162,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("09/03/2023"),
            tuition6: 4097.10,
            fee6: 0,
            textbooks6: 161,
            supplies6: 0,
            uniform6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("11/03/2023")
        }
    },
    "05162022": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("08/11/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7055,
            fee1: 0,
            textbooks1: 245,
            supplies1: 1375,
            uniform1: 116,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/25/2022"),
            tuition2: 7055,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/19/2023"),
            tuition3: 5497.84,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("05/14/2023"),
            tuition4: 5497.84,
            fee4: 0,
            textbooks4: 54,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("08/11/2023"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: 0,
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("05/12/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6330,
            fee1: 0,
            textbooks1: 626,
            supplies1: 559,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/25/2022"),
            tuition2: 6330,
            fee2: 0,
            textbooks2: 97,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/19/2023"),
            tuition3: 4922,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("05/12/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: 0,
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: 0,
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC_DISABLED: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("05/12/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6804,
            fee1: 0,
            textbooks1: 609,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/25/2022"),
            tuition2: 6804,
            fee2: 0,
            textbooks2: 609,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/19/2023"),
            tuition3: 4534.5,
            fee3: 599.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("05/12/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("05/12/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7451,
            fee1: 0,
            textbooks1: 279,
            supplies1: 532,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/25/2022"),
            tuition2: 7451,
            fee2: 0,
            textbooks2: 139,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/19/2023"),
            tuition3: 5499.4,
            fee3: 0,
            textbooks3: 110,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("05/12/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: 0,
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: 0,
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MT: {
            programType: "Contact_Clock",
            programHour: 750,
            programLength: 9,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("02/17/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6203,
            fee1: 0,
            textbooks1: 454,
            supplies1: 315,
            uniform1: 68,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("10/02/2022"),
            tuition2: 6202,
            fee2: 0,
            textbooks2: 54,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/17/2023"),
            tuition3: "",
            fee3: "",
            textbooks3: "",
            supplies3: "",
            other3: "",
            paymentReceive3: "",
            cancellationFee3: "",
            endDate3: "",
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 90,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("11/03/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6746,
            fee1: 0,
            textbooks1: 225,
            supplies1: 532,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/04/2022"),
            tuition2: 6746,
            fee2: 0,
            textbooks2: 139,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/08/2023"),
            tuition3: 6746,
            fee3: 0,
            textbooks3: 109,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("04/23/2023"),
            tuition4: 6746,
            fee4: 0,
            textbooks4: 280,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("08/13/2023"),
            tuition5: 6584.1,
            fee5: 0,
            textbooks5: 108,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("11/03/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 90.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("11/03/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 5700,
            fee1: 0,
            textbooks1: 605,
            supplies1: 559,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/04/2022"),
            tuition2: 5700,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/08/2023"),
            tuition3: 5699,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("04/23/2023"),
            tuition4: 5699,
            fee4: 0,
            textbooks4: 194,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("08/13/2023"),
            tuition5: 4171,
            fee5: 0,
            textbooks5: 194,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("11/03/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ATM_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 94.5,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("12/15/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6190,
            fee1: 0,
            textbooks1: 244,
            supplies1: 1375,
            uniform1: 116,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/04/2022"),
            tuition2: 6189,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/08/2023"),
            tuition3: 6189,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("04/23/2023"),
            tuition4: 6189,
            fee4: 0,
            textbooks4: 54,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("08/13/2023"),
            tuition5: 4097.11,
            fee5: 0,
            textbooks5: 162,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("10/15/2023"),
            tuition6: 4097.10,
            fee6: 0,
            textbooks6: 161,
            supplies6: 0,
            uniform6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("12/15/2023")
        }
    },
    "07052022": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("09/22/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7055,
            fee1: 0,
            textbooks1: 245,
            supplies1: 1375,
            uniform1: 116,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/06/2022"),
            tuition2: 7055,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/02/2023"),
            tuition3: 5497.84,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("07/02/2023"),
            tuition4: 5497.84,
            fee4: 0,
            textbooks4: 54,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("09/22/2023"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: 0,
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("06/23/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6330,
            fee1: 0,
            textbooks1: 626,
            supplies1: 559,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/06/2022"),
            tuition2: 6330,
            fee2: 0,
            textbooks2: 97,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/02/2023"),
            tuition3: 4922,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("06/23/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: 0,
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: 0,
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC_DISABLED: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("06/23/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6804,
            fee1: 0,
            textbooks1: 609,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/06/2022"),
            tuition2: 6804,
            fee2: 0,
            textbooks2: 609,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/02/2023"),
            tuition3: 4534.5,
            fee3: 599.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("06/23/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("06/23/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7451,
            fee1: 0,
            textbooks1: 279,
            supplies1: 532,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/06/2022"),
            tuition2: 7451,
            fee2: 0,
            textbooks2: 139,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/02/2023"),
            tuition3: 5499.4,
            fee3: 0,
            textbooks3: 110,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("06/23/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: 0,
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: 0,
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MT: {
            programType: "Contact_Clock",
            programHour: 750,
            programLength: 9,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("03/31/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6203,
            fee1: 0,
            textbooks1: 454,
            supplies1: 315,
            uniform1: 68,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/13/2022"),
            tuition2: 6202,
            fee2: 0,
            textbooks2: 54,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("03/31/2023"),
            tuition3: "",
            fee3: "",
            textbooks3: "",
            supplies3: "",
            other3: "",
            paymentReceive3: "",
            cancellationFee3: "",
            endDate3: "",
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 90,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("12/15/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6746,
            fee1: 0,
            textbooks1: 225,
            supplies1: 532,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("10/16/2022"),
            tuition2: 6746,
            fee2: 0,
            textbooks2: 139,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/19/2023"),
            tuition3: 6746,
            fee3: 0,
            textbooks3: 109,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("06/04/2023"),
            tuition4: 6746,
            fee4: 0,
            textbooks4: 280,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("09/24/2023"),
            tuition5: 6584.1,
            fee5: 0,
            textbooks5: 108,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("12/15/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 90.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("12/15/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 5700,
            fee1: 0,
            textbooks1: 605,
            supplies1: 559,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("10/16/2022"),
            tuition2: 5700,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/19/2023"),
            tuition3: 5699,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("06/04/2023"),
            tuition4: 5699,
            fee4: 0,
            textbooks4: 194,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("09/24/2023"),
            tuition5: 4171,
            fee5: 0,
            textbooks5: 194,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("12/15/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ATM_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 94.5,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("02/16/2024"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6190,
            fee1: 0,
            textbooks1: 244,
            supplies1: 1375,
            uniform1: 116,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("10/16/2022"),
            tuition2: 6189,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/19/2023"),
            tuition3: 6189,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("06/04/2023"),
            tuition4: 6189,
            fee4: 0,
            textbooks4: 54,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("09/24/2023"),
            tuition5: 4097.11,
            fee5: 0,
            textbooks5: 162,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("11/26/2023"),
            tuition6: 4097.10,
            fee6: 0,
            textbooks6: 161,
            supplies6: 0,
            uniform6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("02/16/2024")
        }
    },
    "08152022": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("11/03/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7055,
            fee1: 0,
            textbooks1: 245,
            supplies1: 1375,
            uniform1: 116,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/08/2023"),
            tuition2: 7055,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/14/2023"),
            tuition3: 5497.84,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("08/13/2023"),
            tuition4: 5497.84,
            fee4: 0,
            textbooks4: 54,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("11/03/2023"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: 0,
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("08/11/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6330,
            fee1: 0,
            textbooks1: 626,
            supplies1: 559,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/08/2023"),
            tuition2: 6330,
            fee2: 0,
            textbooks2: 97,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/14/2023"),
            tuition3: 4922,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("08/11/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: 0,
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: 0,
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC_DISABLED: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("08/11/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6804,
            fee1: 0,
            textbooks1: 609,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/08/2023"),
            tuition2: 6804,
            fee2: 0,
            textbooks2: 609,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/14/2023"),
            tuition3: 4534.5,
            fee3: 599.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("08/11/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("08/11/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7451,
            fee1: 0,
            textbooks1: 279,
            supplies1: 532,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/08/2023"),
            tuition2: 7451,
            fee2: 0,
            textbooks2: 139,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/14/2023"),
            tuition3: 5499.4,
            fee3: 0,
            textbooks3: 110,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("08/11/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: 0,
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: 0,
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MT: {
            programType: "Contact_Clock",
            programHour: 750,
            programLength: 9,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("05/12/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6203,
            fee1: 0,
            textbooks1: 454,
            supplies1: 315,
            uniform1: 68,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/15/2023"),
            tuition2: 6202,
            fee2: 0,
            textbooks2: 54,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/12/2023"),
            tuition3: "",
            fee3: "",
            textbooks3: "",
            supplies3: "",
            other3: "",
            paymentReceive3: "",
            cancellationFee3: "",
            endDate3: "",
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 90,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("02/16/2024"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6746,
            fee1: 0,
            textbooks1: 225,
            supplies1: 532,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/27/2022"),
            tuition2: 6746,
            fee2: 0,
            textbooks2: 139,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/02/2023"),
            tuition3: 6746,
            fee3: 0,
            textbooks3: 109,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("07/23/2023"),
            tuition4: 6746,
            fee4: 0,
            textbooks4: 280,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("11/05/2023"),
            tuition5: 6584.1,
            fee5: 0,
            textbooks5: 108,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("02/16/2024"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 90.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("02/16/2024"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 5700,
            fee1: 0,
            textbooks1: 605,
            supplies1: 559,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/27/2022"),
            tuition2: 5700,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/02/2023"),
            tuition3: 5699,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("07/23/2023"),
            tuition4: 5699,
            fee4: 0,
            textbooks4: 194,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("11/05/2023"),
            tuition5: 4171,
            fee5: 0,
            textbooks5: 194,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("02/16/2024"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ATM_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 94.5,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("03/29/2024"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6190,
            fee1: 0,
            textbooks1: 244,
            supplies1: 1375,
            uniform1: 116,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/27/2022"),
            tuition2: 6189,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/02/2023"),
            tuition3: 6189,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("07/23/2023"),
            tuition4: 6189,
            fee4: 0,
            textbooks4: 54,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("11/05/2023"),
            tuition5: 4097.11,
            fee5: 0,
            textbooks5: 162,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("01/28/2024"),
            tuition6: 4097.10,
            fee6: 0,
            textbooks6: 161,
            supplies6: 0,
            uniform6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("03/29/2024")
        }
    },
    "09262022": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("12/15/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7055,
            fee1: 0,
            textbooks1: 245,
            supplies1: 1375,
            uniform1: 116,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/19/2023"),
            tuition2: 7055,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/02/2023"),
            tuition3: 5497.84,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/24/2023"),
            tuition4: 5497.84,
            fee4: 0,
            textbooks4: 54,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("12/15/2023"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: 0,
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("09/22/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6330,
            fee1: 0,
            textbooks1: 626,
            supplies1: 559,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/19/2023"),
            tuition2: 6330,
            fee2: 0,
            textbooks2: 97,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/02/2023"),
            tuition3: 4922,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/22/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: 0,
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: 0,
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC_DISABLED: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("09/22/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6804,
            fee1: 0,
            textbooks1: 609,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/19/2023"),
            tuition2: 6804,
            fee2: 0,
            textbooks2: 609,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/02/2023"),
            tuition3: 4534.5,
            fee3: 599.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/22/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("09/22/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7451,
            fee1: 0,
            textbooks1: 279,
            supplies1: 532,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/19/2023"),
            tuition2: 7451,
            fee2: 0,
            textbooks2: 139,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/02/2023"),
            tuition3: 5499.4,
            fee3: 0,
            textbooks3: 110,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/22/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: 0,
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: 0,
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MT: {
            programType: "Contact_Clock",
            programHour: 750,
            programLength: 9,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("06/23/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6203,
            fee1: 0,
            textbooks1: 454,
            supplies1: 315,
            uniform1: 68,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/26/2023"),
            tuition2: 6202,
            fee2: 0,
            textbooks2: 54,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("06/23/2023"),
            tuition3: "",
            fee3: "",
            textbooks3: "",
            supplies3: "",
            other3: "",
            paymentReceive3: "",
            cancellationFee3: "",
            endDate3: "",
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 90,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("03/29/2024"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6746,
            fee1: 0,
            textbooks1: 225,
            supplies1: 532,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/29/2023"),
            tuition2: 6746,
            fee2: 0,
            textbooks2: 139,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/14/2023"),
            tuition3: 6746,
            fee3: 0,
            textbooks3: 109,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/03/2023"),
            tuition4: 6746,
            fee4: 0,
            textbooks4: 280,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("01/07/2024"),
            tuition5: 6584.1,
            fee5: 0,
            textbooks5: 108,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("03/29/2024"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 90.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("03/29/2024"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 5700,
            fee1: 0,
            textbooks1: 605,
            supplies1: 559,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/29/2023"),
            tuition2: 5700,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/14/2023"),
            tuition3: 5699,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/03/2023"),
            tuition4: 5699,
            fee4: 0,
            textbooks4: 194,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("01/07/2024"),
            tuition5: 4171,
            fee5: 0,
            textbooks5: 194,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("03/29/2024"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ATM_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 94.5,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("05/10/2024"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6190,
            fee1: 0,
            textbooks1: 244,
            supplies1: 1375,
            uniform1: 116,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/29/2023"),
            tuition2: 6189,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/14/2023"),
            tuition3: 6189,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/03/2023"),
            tuition4: 6189,
            fee4: 0,
            textbooks4: 54,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("01/07/2024"),
            tuition5: 4097.11,
            fee5: 0,
            textbooks5: 162,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("03/10/2024"),
            tuition6: 4097.10,
            fee6: 0,
            textbooks6: 161,
            supplies6: 0,
            uniform6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("05/10/2024")
        }
    },
    "11072022": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("02/16/2024"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7055,
            fee1: 0,
            textbooks1: 245,
            supplies1: 1375,
            uniform1: 116,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/02/2023"),
            tuition2: 7055,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/13/2023"),
            tuition3: 5497.84,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/05/2023"),
            tuition4: 5497.84,
            fee4: 0,
            textbooks4: 54,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("02/16/2024"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: 0,
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("11/03/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6330,
            fee1: 0,
            textbooks1: 626,
            supplies1: 559,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/02/2023"),
            tuition2: 6330,
            fee2: 0,
            textbooks2: 97,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/13/2023"),
            tuition3: 4922,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/03/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: 0,
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: 0,
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC_DISABLED: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("11/03/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6804,
            fee1: 0,
            textbooks1: 609,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/02/2023"),
            tuition2: 6804,
            fee2: 0,
            textbooks2: 609,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/13/2023"),
            tuition3: 4534.5,
            fee3: 599.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/03/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("11/03/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7451,
            fee1: 0,
            textbooks1: 279,
            supplies1: 532,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/02/2023"),
            tuition2: 7451,
            fee2: 0,
            textbooks2: 139,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/13/2023"),
            tuition3: 5499.4,
            fee3: 0,
            textbooks3: 110,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/03/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: 0,
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: 0,
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MT: {
            programType: "Contact_Clock",
            programHour: 750,
            programLength: 9,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("08/11/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6203,
            fee1: 0,
            textbooks1: 454,
            supplies1: 315,
            uniform1: 68,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/09/2023"),
            tuition2: 6202,
            fee2: 0,
            textbooks2: 54,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/11/2023"),
            tuition3: "",
            fee3: "",
            textbooks3: "",
            supplies3: "",
            other3: "",
            paymentReceive3: "",
            cancellationFee3: "",
            endDate3: "",
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 90,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("05/10/2024"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6746,
            fee1: 0,
            textbooks1: 225,
            supplies1: 532,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("03/12/2023"),
            tuition2: 6746,
            fee2: 0,
            textbooks2: 139,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/02/2023"),
            tuition3: 6746,
            fee3: 0,
            textbooks3: 109,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("10/15/2023"),
            tuition4: 6746,
            fee4: 0,
            textbooks4: 280,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("02/18/2024"),
            tuition5: 6584.1,
            fee5: 0,
            textbooks5: 108,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("05/10/2024"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 90.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("05/10/2024"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 5700,
            fee1: 0,
            textbooks1: 605,
            supplies1: 559,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("03/12/2023"),
            tuition2: 5700,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/02/2023"),
            tuition3: 5699,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("10/15/2023"),
            tuition4: 5699,
            fee4: 0,
            textbooks4: 194,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("02/18/2024"),
            tuition5: 4171,
            fee5: 0,
            textbooks5: 194,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("05/10/2024"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: 0,
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ATM_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 94.5,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("06/21/2024"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6190,
            fee1: 0,
            textbooks1: 244,
            supplies1: 1375,
            uniform1: 116,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("03/12/2023"),
            tuition2: 6189,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/02/2023"),
            tuition3: 6189,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("10/15/2023"),
            tuition4: 6189,
            fee4: 0,
            textbooks4: 54,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("02/18/2024"),
            tuition5: 4097.11,
            fee5: 0,
            textbooks5: 162,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("04/21/2024"),
            tuition6: 4097.10,
            fee6: 0,
            textbooks6: 161,
            supplies6: 0,
            uniform6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("06/21/2024")
        }
    }
};
//# sourceMappingURL=data:application/json;base64,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